import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './obrapublica.css';

const ObraPublica = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container obra-publica-container'>
        <div className='row'>
            <div className='col-12'>
                <div className='obra_publica_title'>
                    <h1>Programa Anual de Obra Pública y Servicios Relacionados con las Mismas del CECULTAH</h1>
                </div>
            </div>
        </div>


        <div className='row'>


          <div class="accordion" id="accordionExampleObra1">
            <div class="shadow mt-4 card-item-licitacion">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOneObraPublica2025a"><button class="accordion-button collapsed arccordion-gris" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOneObraPublica2025a" aria-expanded="false" aria-controls="collapseOneObraPublica2025a">PAOPS 2025</button></h2>
              <div id="collapseOneObraPublica2025a" class="accordion-collapse collapse" aria-labelledby="headingOneObraPublica2025a" data-bs-parent="#accordionExampleObra1">
                 <div class="accordion-body">
                    <ul class="list-group">
                    <li class="list-group-item">PAOPS | 2025<a class="card_trimestre bg-secondary" href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2025/procedimientos/Programa%20de%20obra%20publica%202025.pdf" target="_blank" rel="noopener noreferrer"><i class="badge bg-secondary-dos-pdf">.pdf</i></a></li>
                    </ul>
                 </div>
              </div>
            </div>

        </div>
        </div>
        </div>


           <div className="espacio"></div>



        </div>
  )
}

export default ObraPublica